export const flexGrowCentered = { 
    display: "flex", 
    flexGrow: 1, 
    justifyContent: "center",
};

export const toolbar = {
    display: { xs: "grid", sm: "flex" },
    gridTemplateColumns: { xs: "minmax(0, 1fr) auto", sm: "none" },
    gridTemplateRows: { xs: "auto auto", sm: "none" },
    alignItems: "center",
    rowGap: { xs: 1, sm: 0 },
    columnGap: { xs: 1, sm: 0 },
    py: { xs: 1, sm: 0 },
    px: { xs: 2.5, sm: 1 },
    width: "100%",
    overflow: "hidden",
};

export const logoLink = {
    gridColumn: { xs: "1 / 2", sm: "auto" },
    gridRow: { xs: "1 / 2", sm: "auto" },
    minWidth: 0,
    "@media (max-width: 599.95px)": {
        "& img": { maxWidth: "100%", mr: 0 },
    },
};

export const searchContainer = {
    ...flexGrowCentered,
    gridColumn: { xs: "1 / 3", sm: "auto" },
    gridRow: { xs: "2 / 3", sm: "auto" },
    alignItems: "center",
    gap: { xs: 1, sm: 0 },
    minWidth: 0,
    width: { xs: "100%", sm: "auto" },
};

export const mobileIconButton = {
    display: { xs: "inline-flex", sm: "none" },
    flexShrink: 0,
};

export const languageSwitcher = {
    flexShrink: 0,
    mr: { xs: 0, sm: 2 },
    mt: { xs: 0, sm: 0.5 },
};

export const headerActions = {
    gridColumn: { xs: "2 / 3", sm: "auto" },
    gridRow: { xs: "1 / 2", sm: "auto" },
    justifySelf: { xs: "end", sm: "auto" },
    minWidth: 0,
    "& .MuiIconButton-edgeEnd": {
        mr: { xs: 0, sm: -1.5 },
    },
};
